'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import { EpUpload } from '../../EpUpload';
import { useTranslation as t } from '../../../hooks/useTranslation';
// import { useUploadStore } from '../../../stores';
import styles from '../Forms/IncidentNotification/Steps/steps.module.scss';

export default function NotificationUploadFiles({
  translations,
}: {
  translations: unknown;
}) {
  const { register, setValue, getValues } = useFormContext();
  const attachedFiles = useWatch({ name: 'AttachedFiles' });
  register('AttachedFiles', { required: false });

  return (
    <div>
      <p className={styles['step3__txt']}>
        {t(
          translations,
          'Attach up to 10 files that may contribute to this notification. (File type: Image, doc or pdf)',
        )}
      </p>
      <EpUpload
        uploadId="EpUpload"
        translations={{
          uploadButtonText: t(translations, 'Search file'),
          noFileSelectedText: t(translations, 'No file chosen'),
          selectedFileText: t(translations, '{0} Selected files').replace(
            '{0}',
            attachedFiles?.length,
          ),
          uploadMaxFilesText: `${t(translations, 'Upload limit of {0}').replace(
            '{0}',
            10,
          )} ${t(translations, 'Files')}`,
          uploadMaxFilesSizeText: t(translations, 'Maximum file size: 10Mb'),
        }}
        uploadFilesCallbackFunc={(files) => setValue('AttachedFiles', files)}
        files={getValues('AttachedFiles')}
      />
    </div>
  );
}
